'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var calculateDimension = {};

exports.__exports = calculateDimension;
